import {
  MultiCurrencyMilesConversion,
} from '@dapi/sdk';
import {
  zeroAmountInSek,
} from './amount';

export const mockMilesConversion: MultiCurrencyMilesConversion = {
  convertedMiles: {
    base: 31_600,
    total: 31_600,
    totalTaxes: 0
  },
  remainingNonConverted: {
    base: zeroAmountInSek,
    total: {
      ...zeroAmountInSek,
      value: 5686
    },
    totalTaxes: {
      ...zeroAmountInSek,
      value: 5686
    }
  }
};

export const mockMilesConversionWithoutCancellation: MultiCurrencyMilesConversion = {
  convertedMiles: {
    base: 19_000,
    total: 19_000,
    totalTaxes: 0
  },
  remainingNonConverted: {
    base: zeroAmountInSek,
    total: {
      ...zeroAmountInSek,
      value: 5825
    },
    totalTaxes: {
      ...zeroAmountInSek,
      value: 5825
    }
  }
};
